import React from 'react';
import { assets } from '../data/landing';
type LogoProps = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};
const sizes = {
  sm: 'h-11 sm:h-12',
  md: 'h-14 sm:h-16',
  lg: 'h-20 sm:h-24'
};

/**
 * Official Pawsy Emprende logo, used exactly as provided.
 * mix-blend-multiply removes the asset's white box over the cream background.
 */
export function Logo({
  size = 'md',
  className = ''
}: LogoProps) {
  return <img src={assets.logo} alt="Pawsy Emprende — tu amor por los animales, tu propio negocio" className={`w-auto object-contain mix-blend-multiply ${sizes[size]} ${className}`} data-id="element-80" data-mp="mu5va9nvxf71" />;
}